import React from "react";
import { Link } from "react-router-dom";
import { programNameFromID, isoDateToMDY } from "../../../../utils/common";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { FileText } from "lucide-react"

export const CalAimForms = ({calaimData, odrNumber}: any) => {
  return (
    <Card className="w-full shadow-sm">
      <CardHeader className="pb-1 pt-2 px-3">
        <div className="flex items-center gap-1.5">
          <FileText className="h-3.5 w-3.5 text-gray-500" />
          <h4 className="text-xs font-medium text-gray-700">ECM Forms</h4>
        </div>
      </CardHeader>
      <CardContent className="pt-0 px-3 pb-2">
        <div className="grid grid-cols-5 gap-4">
          <div className="flex flex-col">
            <Link 
              to={`/documents/${odrNumber}`}
              className="text-xs text-blue-600 hover:text-blue-800 hover:underline mb-1"
            >
              Initial Assessment
            </Link>
            <span className="text-xs text-gray-600">
              {isoDateToMDY(calaimData.lastInitialAssessmentDate?.date) || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <Link 
              to={`/documents/${odrNumber}`}
              className="text-xs text-blue-600 hover:text-blue-800 hover:underline mb-1"
            >
              Care Plan
            </Link>
            <span className="text-xs text-gray-600">
              {isoDateToMDY(calaimData.lastLACAREScreeningDate?.date) || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <Link 
              to={`/documents/${odrNumber}`}
              className="text-xs text-blue-600 hover:text-blue-800 hover:underline mb-1"
            >
              Program Completion
            </Link>
            <span className="text-xs text-gray-600">
              {isoDateToMDY(calaimData.lastProgramCompletionDate?.date) || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <Link 
              to={`/documents/${odrNumber}`}
              className="text-xs text-blue-600 hover:text-blue-800 hover:underline mb-1"
            >
              LA Care Forms
            </Link>
            <span className="text-xs text-gray-600">
              —
            </span>
          </div>

          <div className="flex flex-col">
            <Link 
              to={`/CalAIM/outreach/${odrNumber}`}
              className="text-xs text-blue-600 hover:text-blue-800 hover:underline mb-1"
            >
              Client Outreach
            </Link>
            <span className="text-xs text-gray-600">
              —
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
